/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type trialEnd_viewer$ref: FragmentReference;
declare export opaque type trialEnd_viewer$fragmentType: trialEnd_viewer$ref;
export type trialEnd_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +company: ?{|
    +id: string,
    +tier: ?TierType,
  |},
  +$refType: trialEnd_viewer$ref,
|};
export type trialEnd_viewer$data = trialEnd_viewer;
export type trialEnd_viewer$key = {
  +$data?: trialEnd_viewer$data,
  +$fragmentRefs: trialEnd_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "trialEnd_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '36432dbf6ac00b8cb27881451eec0703';

module.exports = node;
